import BaseComponent from '../abstracts/BaseComponent';

const debug = false;

export default class StoryGallery extends BaseComponent {

  constructor(element) {
    super(element);
    debug && console.log('StoryGallery');

    this.overlay = document.querySelector('.gallery-overlay');
    this.slideshow = this.overlay.querySelector('.slideshow');

    this.$el.querySelectorAll('.gallery-item-link').forEach(element => element.addEventListener('click', this.itemClick));
    this.overlay.querySelector('.overlay-close').addEventListener('click', this.closeClick);
    this.overlay.querySelectorAll('.slideshow-button').forEach(element => element.addEventListener('click', this.slideshowButtonClick));
    this.slideshow.addEventListener('click', this.slideshowClick);

    // MU-609
    this.lightweightMasonry();
  }

  itemClick = event => {
    event.preventDefault();
    debug && console.log('StoryGallery itemClick');

    const item = event.currentTarget.closest('.gallery-item');
    const items = item.closest('.gallery').querySelectorAll('.gallery-item');
    this.index = Array.prototype.indexOf.call(items, item);
    this.length = items.length;

    items.forEach(item1 => {
    	const item2 = document.createElement('div');
    	item2.classList.add('slideshow-item');
    	const item3 = item1.cloneNode(true);
    	item3.style.removeProperty('margin-top');
    	item2.append(item3);
    	this.slideshow.append(item2);
    });

    /*
    const first = this.slideshow.firstElementChild;
    const last = this.slideshow.lastElementChild;
    this.slideshow.prepend(last.cloneNode(true));
    this.slideshow.append(first.cloneNode(true));
    */

    /*
    this.slideshow.style.transition = 'none';
    setTimeout(() => {
      this.foo();
      setTimeout(() => this.slideshow.style.transition = '', 10);
    }, 10);

    document.documentElement.classList.add('story-gallery');
    */

    this.small = window.innerWidth < 768;
    this.show();
  }

  closeClick = event => {
    event.preventDefault();
    debug && console.log('StoryGallery closeClick');
    document.documentElement.classList.remove('story-gallery');
    this.slideshow.innerHTML = '';
    this.slideshow.classList.remove('zoom');
  }

  slideshowButtonClick = event => {
    event.preventDefault();
    debug && console.log('StoryGallery slideshowButtonClick');
    const next = event.currentTarget.classList.contains('slideshow-next');
    this.index += next ? 1 : -1;
    this.show();
  }

  show = () => {
    debug && console.log('StoryGallery show', this.index);
    const open = !document.documentElement.classList.contains('story-gallery');

    this.overlay.querySelectorAll('.slideshow-button').forEach(element => {
      const hide1 = this.index == 0 && element.classList.contains('slideshow-previous');
      const hide2 = this.index == this.length - 1 && element.classList.contains('slideshow-next');
      element.style.display = hide1 || hide2 ? 'none' : '';
    });

    if (open) this.slideshow.style.transition = 'none';
    this.slideshow.style.transform = `translateX(${(this.small ? 100 : 75) - (this.small ? 100 : 50) * (1 + this.index)}%)`;
    open && setTimeout(() => {
      this.slideshow.style.transition = '';
      document.documentElement.classList.add('story-gallery');
    }, 10);

    const slide0 = !open && this.slide;
    this.slide = this.slideshow.querySelector(`.slideshow-item:nth-of-type(${this.index + 1})`);

    if (this.small) {
      slide0 && slide0.classList.remove('active');
      this.slide.classList.add('active');
      return;
    }

    if (slide0) {
      const item0 = slide0.querySelector('.gallery-item');
      item0.style.width = item0.dataset.width + 'px';
      setTimeout(() => {
        slide0.classList.remove('active');
        item0.style.width = '';
      }, 510);
    }

    const item = this.slide.querySelector('.gallery-item');
    setTimeout(() => {
      const width = item.offsetWidth;
      item.style.width = width + 'px';
      item.dataset.width = width;
      const width2 = (0.95 * window.innerHeight / item.offsetHeight) * width;
      this.slide.classList.add('active');

      if (open) item.style.transition = 'none';
      item.style.width = width2 + 'px';
      open && setTimeout(() => item.style.transition = '', 10);
    }, open ? 510 : 10);
  }

  slideshowClick = event => {
    debug && console.log('StoryGallery slideshowClick');
    if (!this.small) return;
    event.preventDefault();

    const target = event.currentTarget;
    target.classList.toggle('zoom');
    if (target.classList.contains('zoom')) {
      const element = event.target.closest('.gallery-item-link');
      element.scrollLeft =  (element.scrollWidth - element.clientWidth) / 2;
    }
  }

  lightweightMasonry = () => {
    // https://css-tricks.com/a-lightweight-masonry-solution/
	// let grids = [...document.querySelectorAll('.grid--masonry')];
	let grids = [this.$el];

	if(grids.length && getComputedStyle(grids[0]).gridTemplateRows !== 'masonry') {
	  grids = grids.map(grid => ({
	    _el: grid, 
	    gap: parseFloat(getComputedStyle(grid).gridRowGap), 
	    items: [...grid.childNodes].filter(c => c.nodeType === 1 && +getComputedStyle(c).gridColumnEnd !== -1), 
	    ncol: 0, 
	    mod: 0
	  }));

	  function layout() {
	    grids.forEach(grid => {
	      /* get the post relayout number of columns */
	      let ncol = getComputedStyle(grid._el).gridTemplateColumns.split(' ').length;
	      debug && console.log('ncol', ncol);

	      grid.items.forEach(c => {
	        let new_h = c.getBoundingClientRect().height;
	        debug && console.log('c', c, 'new_h', new_h);
	        
	        if(new_h !== +c.dataset.h) {
	          c.dataset.h = new_h;
	          grid.mod++
	        }
	      });

	      /* if the number of columns has changed */
	      if(grid.ncol !== ncol || grid.mod) {
	        /* update number of columns */
	        grid.ncol = ncol;

	        /* revert to initial positioning, no margin */
	        grid.items.forEach(c => c.style.removeProperty('margin-top'));

	        /* if we have more than one column */
	        if(grid.ncol > 1) {
	          grid.items.slice(ncol).forEach((c, i) => {
	            let prev_fin = grid.items[i].getBoundingClientRect().bottom /* bottom edge of item above */, 
	                curr_ini = c.getBoundingClientRect().top /* top edge of current item */;
	            debug && console.log('c', c, 'prev_fin', prev_fin, 'curr_ini', curr_ini);

	            c.style.marginTop = `${prev_fin + grid.gap - curr_ini}px`
	          })
	        }

	        grid.mod = 0
	      }
	    })
	  }

	  addEventListener('load', e => {
	    layout(); /* initial load */
	    addEventListener('resize', layout, false) /* on resize */
	  }, false);
	}
  }
}
